import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import { PanelSmall } from '../shared/PanelSmall';
import { body, heading } from './content';

export const BestRetirementSmall = () => (
  <PanelSmall
    image={<StaticImage src="../images/expert-1.webp" alt="advisor" />}
    heading={heading}
    body={body}
  />
);
